import { useState } from 'react';
import OTPInput from 'react-otp-input';
import { Translate } from '~/i18n';
import { parseTime } from '~/i18n/_helpers';
import { Button } from '~/components/common/button';
import Timer from '~/components/common/timer';
import { ReviewBubbleIcon } from '~/svgs/header';
type OTPProps = {
   phoneNumber: string;
   close: () => any;
   submitOTP: (smsCode: string) => any;
   resendCode: () => void;
   loading: boolean;
   error?: string;
};

const OTPVerify = ({
   phoneNumber,
   close,
   submitOTP,
   resendCode,
   loading = false,
   error,
}: OTPProps) => {
   const [otp, setOtp] = useState('');
   const [waitOTP, setWaitOTP] = useState(true);
   return (
      <div className="flex flex-col items-center text-center">
         <ReviewBubbleIcon width={45} height={45} className="[&>*]:fill-primary" />
         <div className="mt-6 text-2xl font-bold">
            <Translate id="auth:enter sms code" />
         </div>
         <div className="px-10 mt-2 text-center">
            <div>
               <Translate id="auth:enter code sent" />
            </div>
            <span className="font-bold" dir="ltr">
               {phoneNumber}
            </span>
         </div>
         <div style={{ direction: 'ltr' }}>
            <OTPInput
               isInputNum
               value={otp}
               numInputs={4}
               onChange={(otp: string) => setOtp(otp)}
               className="px-2 text-primary h-[50px] otp-input ltr"
               containerStyle={{
                  width: '100%',
                  display: 'flex',
                  justifyContent: 'center',
                  margin: '24px 0px',
               }}
               inputStyle={{
                  width: '100%',
                  maxWidth: '50px',
                  fontSize: '1rem',
                  border: '1px solid #DADADA',
                  height: '100%',
                  borderRadius: '8px',
               }}
            />
            {error && <div className="mb-5 text-sm text-red">{error}</div>}
            <div className="flex justify-between ">
               <Button
                  onClick={() => close()}
                  theme="outline-primary"
                  disabled={loading}
                  className="!w-40 h-11 font-semibold mb-9 !py-3 ltr:mr-2 rtl:ml-2">
                  {<Translate id="common:cancel" />}
               </Button>
               <Button
                  onClick={() => submitOTP(otp)}
                  theme="primary"
                  loading={loading}
                  disabled={loading}
                  className="!w-40 h-11 font-semibold mb-9 !py-3 ltr:mr-2 rtl:ml-2">
                  {<Translate id="common:continue" />}
               </Button>
            </div>
         </div>
         {waitOTP ? (
            <Timer
               time={60}
               onTimeFinished={() => setWaitOTP(false)}
               component={({ time }) => (
                  <span className="font-medium text-gray-500">
                     <Translate id="auth:request code after" values={{ time: parseTime(time) }} />
                  </span>
               )}
            />
         ) : (
            <button
               onClick={() => {
                  resendCode();
                  setWaitOTP(true);
               }}
               className="font-medium text-primary hover:underline">
               <Translate id="auth:request new code" />
            </button>
         )}
      </div>
   );
};

export default OTPVerify;
